import gql from 'graphql-tag';

export { CREATE_USER } from './createUser';
export { GET_USER_SERVICES_SUMMARY } from './GET_USER_SERVICES_SUMMARY';

export const USER_FRAGMENT = gql`
	fragment user on User {
		id
		isSuperAdmin
		canManageChatChannels
		username
		firstname
		lastname
		overrideHideFutureRunsFromDriversSetting
		hideFutureRunsFromDrivers
		tenants {
			id
			name
			isMaster
		}
		accessTenants {
			id
			name
			isMaster
		}
		role {
			id
			name
			permissions
			homePage
			mobileHomePage
			canSeeAdminNotes
			viewDataDriverIsAssignedTo
		}
		extraAccess {
			until
			role {
				id
				name
				permissions
			}
		}
		enabled
		scopingModel
		tenant {
			id
			name
			isMaster
			email
			timezone
			windcaveCustomerId
			netcardCustomerId
			awsUserId
			logoUrl
			publicName
			publicEmail
			publicPhoneNumber
			region
			masterTenant {
				id
				tenantSettings {
					id
					managesSlaveProducts
					managesSlaveConstants
					managesSlaves
					managesSlaveLocationsClients
					managesSlaveMachines
					managesSlaveTags
						managesSlaveClients
						managesSlaveCommissions
						peopleOnboardingChecklistDetails
						peopleOffboardingChecklistDetails
						peopleDefaultSuperannuationFund
						peopleDefaultInjuryEventReviewer {
							id
							firstname
							lastname
							username
							destroyed
						}
						peopleDefaultIncidentEventReviewer {
							id
							firstname
							lastname
							username
							destroyed
						}
						peopleDocumentExpiryNotificationRecipients {
							id
							firstname
							lastname
							username
							destroyed
						}
						peopleDocumentReminderNotificationRecipients {
							id
							firstname
							lastname
							username
							destroyed
						}
						peopleDocumentActionNotificationRecipients {
							id
							firstname
							lastname
							username
							destroyed
						}
						peopleOnboardingCompletionNotificationRecipients {
							id
							firstname
							lastname
							username
							destroyed
						}
						peopleEmployeeEventSubmissionNotificationRecipients {
							id
							firstname
							lastname
							username
							destroyed
						}
						peopleTrainingReminderNotificationRecipients {
							id
							firstname
							lastname
							username
							destroyed
						}
						peopleTrainingReviewNotificationRecipients {
							id
							firstname
							lastname
							username
							destroyed
						}
						peopleProbationReminderNotificationRecipients {
							id
							firstname
							lastname
							username
							destroyed
						}
						peopleXeroSyncFailureNotificationRecipients {
							id
							firstname
							lastname
							username
							destroyed
						}
						peopleEmploymentChangeNotificationRecipients {
							id
							firstname
							lastname
							username
							destroyed
						}
						peoplePayrollDetailApprovalNotificationRecipients {
							id
							firstname
							lastname
							username
							destroyed
						}
						peoplePayrollLeaveUpdateNotificationRecipients {
							id
							firstname
							lastname
							username
							destroyed
						}
						peopleOvertimeWarningNotificationRecipients {
							id
							firstname
							lastname
							username
							destroyed
						}
						peopleDocumentReminderNotificationDeliveryMode
						peopleDocumentActionNotificationDeliveryMode
						peopleOnboardingCompletionNotificationDeliveryMode
						peopleEmployeeEventSubmissionNotificationDeliveryMode
						peopleTrainingReminderNotificationDeliveryMode
						peopleTrainingReviewNotificationDeliveryMode
						peopleProbationReminderNotificationDeliveryMode
						peopleXeroSyncFailureNotificationDeliveryMode
						peopleEmploymentChangeNotificationDeliveryMode
						peoplePayrollDetailApprovalNotificationDeliveryMode
						peoplePayrollLeaveUpdateNotificationDeliveryMode
						peopleOvertimeWarningNotificationDeliveryMode
						peopleVehicleFineReminderNotificationDeliveryMode
						peopleVehicleFineReminderNotificationRecipients {
							id
							firstname
							lastname
							username
							destroyed
						}
						peopleWeeklyDigestEmailRecipients
						peopleWeeklyDigestEmailRecipientsMode
						peopleWeeklyDigestEmailDeliveryMode
						peopleWeeklyDigestEmailRecipientsUsers {
							id
							firstname
							lastname
							username
							destroyed
						}
						peopleDocumentReminderNotificationRecipientsMode
						peopleDocumentReminderNotificationRecipientsEmails
						peopleDocumentActionNotificationRecipientsMode
						peopleDocumentActionNotificationRecipientsEmails
						peopleOnboardingCompletionNotificationRecipientsMode
						peopleOnboardingCompletionNotificationRecipientsEmails
						peopleEmployeeEventSubmissionNotificationRecipientsMode
						peopleEmployeeEventSubmissionNotificationRecipientsEmails
						peopleTrainingReminderNotificationRecipientsMode
						peopleTrainingReminderNotificationRecipientsEmails
						peopleTrainingReviewNotificationRecipientsMode
						peopleTrainingReviewNotificationRecipientsEmails
						peopleProbationReminderNotificationRecipientsMode
						peopleProbationReminderNotificationRecipientsEmails
						peopleXeroSyncFailureNotificationRecipientsMode
						peopleXeroSyncFailureNotificationRecipientsEmails
						peopleEmploymentChangeNotificationRecipientsMode
						peopleEmploymentChangeNotificationRecipientsEmails
						peoplePayrollLeaveUpdateNotificationRecipientsMode
						peoplePayrollLeaveUpdateNotificationRecipientsEmails
						peopleOvertimeWarningNotificationRecipientsMode
						peopleOvertimeWarningNotificationRecipientsEmails
						peopleVehicleFineReminderNotificationRecipientsMode
						peopleVehicleFineReminderNotificationRecipientsEmails
					}
			}
		}
		phone
		deputyEmployeeId
		deputyDisplayName
		deputyMatchedAt
		profilePhotoUrl
		settings
		defaultSetupSubscribers {
			id
			firstname
			lastname
			username
		}
		gameScore
		gameAttempts
		tenantSettings {
			id
			salesLast7DaysMode
			averageDailySalesLast7DaysThresholds
			salesLast7DaysThresholds
			expiryDateThresholds
			SPECThresholds
			totalPickItemsQuantityThresholds
			vendoutThresholds
			planogramItemSalesLastXDaysThresholds
			machineProductLastRemovedDateThresholds
			planogramItemDaysSinceLastSale
			temperatureThresholds
			lastCommThresholds
			requiredCoinsThresholds
			requiredCoinsPercentageThresholds
			warehouseStockCanGoNegative
			pickedStockCanExceedWarehouseStock
			quantityDisplayedInCases
			syncProductsWithGlobal
			processRestockWhenNoServiceRun
			enableFreshFoodPerStop
			useProductSizeUnit
			defaultCashCollectionSetting
			oneCashBagPerServiceRun
			defaultCashCollectionAbove
			sendVehicleRegistrationRenewalEmailNotification
			vehicleRegistrationRenewalEmailNotificationRecipients
			vehicleServiceDueEmailNotificationRecipients
			emailNotificationRecipients
			productDiscontinuationEmailRecipients
			weeklyOperationsEmailRecipients
			weeklyClientsSalesEmailRecipients
			incomingAssetOrderEmailRecipients
			vehicleNotificationEmailRecipients
			notificationRecipients {
				id
				firstname
				lastname
				username
				destroyed
			}
			marketFeedbackEmailRecipients {
				id
				firstname
				lastname
				username
				destroyed
			}
			kamCommissionRunFinalisationRecipients {
				id
				firstname
				lastname
				username
				destroyed
			}
			kamCommissionRunFinalisationDeliveryMode
			kamCommissionRunStatementCcRecipients {
				id
				firstname
				lastname
				username
				destroyed
			}
			kamCommissionRunStatementCcDeliveryMode
			peopleDocumentExpiryNotificationRecipients {
				id
				firstname
				lastname
				username
				destroyed
			}
			peopleDocumentReminderNotificationRecipients {
				id
				firstname
				lastname
				username
				destroyed
			}
			peopleDocumentActionNotificationRecipients {
				id
				firstname
				lastname
				username
				destroyed
			}
			peopleOnboardingCompletionNotificationRecipients {
				id
				firstname
				lastname
				username
				destroyed
			}
			peopleEmployeeEventSubmissionNotificationRecipients {
				id
				firstname
				lastname
				username
				destroyed
			}
			peopleTrainingReminderNotificationRecipients {
				id
				firstname
				lastname
				username
				destroyed
			}
			peopleTrainingReviewNotificationRecipients {
				id
				firstname
				lastname
				username
				destroyed
			}
			peopleProbationReminderNotificationRecipients {
				id
				firstname
				lastname
				username
				destroyed
			}
			peopleXeroSyncFailureNotificationRecipients {
				id
				firstname
				lastname
				username
				destroyed
			}
			peopleEmploymentChangeNotificationRecipients {
				id
				firstname
				lastname
				username
				destroyed
			}
			peoplePayrollDetailApprovalNotificationRecipients {
				id
				firstname
				lastname
				username
				destroyed
			}
			peoplePayrollLeaveUpdateNotificationRecipients {
				id
				firstname
				lastname
				username
				destroyed
			}
			peopleOvertimeWarningNotificationRecipients {
				id
				firstname
				lastname
				username
				destroyed
			}
			peopleDocumentReminderNotificationDeliveryMode
			peopleDocumentActionNotificationDeliveryMode
			peopleOnboardingCompletionNotificationDeliveryMode
			peopleEmployeeEventSubmissionNotificationDeliveryMode
			peopleTrainingReminderNotificationDeliveryMode
			peopleTrainingReviewNotificationDeliveryMode
			peopleProbationReminderNotificationDeliveryMode
			peopleXeroSyncFailureNotificationDeliveryMode
			peopleEmploymentChangeNotificationDeliveryMode
			peoplePayrollDetailApprovalNotificationDeliveryMode
			peoplePayrollLeaveUpdateNotificationDeliveryMode
			peopleOvertimeWarningNotificationDeliveryMode
			peopleVehicleFineReminderNotificationDeliveryMode
			peopleVehicleFineReminderNotificationRecipients {
				id
				firstname
				lastname
				username
				destroyed
			}
			peopleWeeklyDigestEmailRecipients
			emailNotificationRecipientsMode
			emailNotificationDeliveryMode
			emailNotificationRecipientsUsers {
				id
				firstname
				lastname
				username
				destroyed
			}
			productDiscontinuationEmailRecipientsMode
			productDiscontinuationEmailDeliveryMode
			productDiscontinuationEmailRecipientsUsers {
				id
				firstname
				lastname
				username
				destroyed
			}
			weeklyOperationsEmailRecipientsMode
			weeklyOperationsEmailDeliveryMode
			weeklyOperationsEmailRecipientsUsers {
				id
				firstname
				lastname
				username
				destroyed
			}
			peopleWeeklyDigestEmailRecipientsMode
			peopleWeeklyDigestEmailDeliveryMode
			peopleWeeklyDigestEmailRecipientsUsers {
				id
				firstname
				lastname
				username
				destroyed
			}
			weeklyClientsSalesEmailRecipientsMode
			weeklyClientsSalesEmailDeliveryMode
			weeklyClientsSalesEmailRecipientsUsers {
				id
				firstname
				lastname
				username
				destroyed
			}
			incomingAssetOrderEmailRecipientsMode
			incomingAssetOrderEmailDeliveryMode
			incomingAssetOrderEmailRecipientsUsers {
				id
				firstname
				lastname
				username
				destroyed
			}
			vehicleNotificationEmailRecipientsMode
			vehicleNotificationEmailDeliveryMode
			vehicleNotificationEmailRecipientsUsers {
				id
				firstname
				lastname
				username
				destroyed
			}
			peopleDocumentReminderNotificationRecipientsMode
			peopleDocumentReminderNotificationRecipientsEmails
			peopleDocumentActionNotificationRecipientsMode
			peopleDocumentActionNotificationRecipientsEmails
			peopleOnboardingCompletionNotificationRecipientsMode
			peopleOnboardingCompletionNotificationRecipientsEmails
			peopleEmployeeEventSubmissionNotificationRecipientsMode
			peopleEmployeeEventSubmissionNotificationRecipientsEmails
			peopleTrainingReminderNotificationRecipientsMode
			peopleTrainingReminderNotificationRecipientsEmails
			peopleTrainingReviewNotificationRecipientsMode
			peopleTrainingReviewNotificationRecipientsEmails
			peopleProbationReminderNotificationRecipientsMode
			peopleProbationReminderNotificationRecipientsEmails
			peopleXeroSyncFailureNotificationRecipientsMode
			peopleXeroSyncFailureNotificationRecipientsEmails
			peopleEmploymentChangeNotificationRecipientsMode
			peopleEmploymentChangeNotificationRecipientsEmails
			peoplePayrollLeaveUpdateNotificationRecipientsMode
			peoplePayrollLeaveUpdateNotificationRecipientsEmails
			peopleOvertimeWarningNotificationRecipientsMode
			peopleOvertimeWarningNotificationRecipientsEmails
			peopleVehicleFineReminderNotificationRecipientsMode
			peopleVehicleFineReminderNotificationRecipientsEmails
			kamCommissionRunFinalisationRecipientsMode
			kamCommissionRunFinalisationRecipientsEmails
			kamCommissionRunStatementCcRecipientsMode
			kamCommissionRunStatementCcRecipientsEmails
			peopleOnboardingChecklistDetails
			peopleOffboardingChecklistDetails
			peopleDefaultSuperannuationFund
			peopleDefaultInjuryEventReviewer {
				id
				firstname
				lastname
				username
				destroyed
			}
			peopleDefaultIncidentEventReviewer {
				id
				firstname
				lastname
				username
				destroyed
			}

			enableServiceRunCreatorPreSelect
			enableServiceRunCreatorCoServiced
			enableServiceRunCreatorLikelyServiceDays
			enableServiceRunCreatorIsolationFilter
			showServiceRunCreatorExclusionHints
			serviceRunPreselectMode
			serviceRunPreselectWeightLimit
			disableServiceRunAdditionsWithoutSitePermissions
			useRosteredDriversForServiceRuns
			defaultMachineServiceType
			defaultRestockEffect
			defaultMachineRestockType
			serviceRunCreatorPreSelectLimits {
				vendouts
				vendoutPredictionTomorrow
				salesSinceLastRestock
				percentageFull
				plannedSalesDailyAverage
				plannedSalesDailyAverageMachine
				plannedSalesDailyAverageMarket
			}
			automaticallyRecalculatePicklists
			automaticallyAssignPickers
			predictivePickLists
			predictivePickListsFromXLastServices
			recalculatePicklistTimeLimit
			machineServiceTime
			performanceReportUpperThreshold
			performanceReportLowerThreshold
			anonymiseReportData
			commissionAbaTraceBsb
			commissionAbaTraceAccountNumber
			commissionAbaFinancialInstitution
			commissionAbaUserNumber
			commissionAbaIncludeSelfBalancingTransaction
			subsidyXeroAccountCode
			subsidyXeroTaxType
			defaultMapCoordinates
			enablePlanogramItemCapacity
			allowEditingPlanogramSelections
			enableTubsFieldOnDockets
			skipWeekendVOP
			skipWeekendMSP
			defaultProductMinPick
			enableTicketsCostsFields
			enableTicketQueues
			disableOtherStateTicketQueues

			requireMachinePhotos
			machinesPhotosIntervalUnit
			machinesPhotosIntervalUnits

			requireMarketPhotos
			marketsPhotosIntervalUnit
			marketsPhotosIntervalUnits
			setPricesFromReportedPrices
			sellProductsNotInMarket
			sortProductsUsingType
			createProductsWhenImportingPlanogram
			balanceProductSwaps
			assignNewPOSToRoute {
				id
				name
			}

			managesSlaveProducts
			managesSlaveConstants
			managesSlaves
			managesSlaveCommissions
			managesSlaveLocationsClients
			managesSlaveMachines
			managesSlaveTags
			managesSlaveClients
			usesMarkets

			recalculateMachineFuturePicklists
			recalculateUnpickedOnly
			showPickListRecalculationDialog

			machineProductSellingRateWeight
			productSellingRateWeight
			lastRemovedDateWeight
			hideFutureRunsFromDrivers
			myDayEnabled
			myDayRequireClockIn
			myDayRequireBriefAcknowledgement
			myDayRequireLeaveWarehouseChecklist
			myDayRequireVehicleChecklist
			myDaySelfDebriefMode
			showVehicleAssignmentDialog
			useExpiryDates
			requireFreshFoodExpiryDates
			showFreshFoodExpiryBeforeNextServiceWarning
			useManualRestockDetails
			enableStockReductionReasonPrompt
			dynamicMinPickEnabled
			dynamicMinPickMultiplier
			dynamicMinPickServicesForAverage
			dynamicMinPickMaxPercentOfParlevel
			maxSalesLast7DaysAchieved
		}
	}
`;

export const GET_USER = gql`
	query ($id: String) {
		getUser (id: $id) {
			...user
		}
	}
	${USER_FRAGMENT}
`;

export const MODIFY_USER = gql`
	mutation modifyUserMutation($input: ModifyUserInput!) {
		modifyUser(input: $input) {
			user {
				...user
			}
		}
	}
	${USER_FRAGMENT}
`;

export const MODIFY_USER_SETTINGS = gql`
	mutation modifyUserSettings ($id: ID!, $settings: JSON!) {
		modifyUserSettings (id: $id, settings: $settings) {
			id
			settings
		}
	}
`;

export const MODIFY_USER_SETTING = gql`
	mutation modifyUserSetting ($id: ID!, $settings: JSON!) {
		modifyUserSetting (id: $id, settings: $settings) {
			id
			settings
		}
	}
`;

export const SWITCH_TENANT = gql`
	mutation switchTenant ($tenantId: ID) {
		switchTenant (tenantId: $tenantId) {
			id
		}
	}
`;

const POS_USER_FRAGMENT = gql`
	fragment POSuser on User {
		id
		profilePhotoUrl
		role {
			id
			permissions
		}
		settings
		deputyEmployeeId
		deputyDisplayName
		deputyMatchedAt
		tenant {
			id
			name
			email
			timezone
			windcaveCustomerId
			netcardCustomerId
			awsUserId
			integrations
			logoUrl
			publicEmail
			publicPhoneNumber
		}
		tenantSettings {
			id
			sellProductsNotInMarket
		}
	}
`;

export const GET_POS_USER = gql`
	query ($id: String) {
		getUser (id: $id) {
			...POSuser
		}
	}
	${POS_USER_FRAGMENT}
`;

export const MODIFY_POS_USER = gql`
	mutation modifyUserMutation($input: ModifyUserInput!) {
		modifyUser(input: $input) {
			user {
				...POSuser
			}
		}
	}
	${POS_USER_FRAGMENT}
`;

export const GET_ADMIN_USER = gql`
	query ($id: String) {
		getUser (id: $id) {
			id
			isSuperAdmin
			firstname
			lastname
			destroyed
			settings
		}
	}
`;

export const GET_USER_NOTES = gql`
	query($id: String) {
		getUser(id: $id) {
			id
			notes {
				id
				description
				created
				isAdminNote
				isImportant
				creator {
					id
					firstname
					lastname
					destroyed
				}
			}
		}
	}
`;
